import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { getCurrentUser } from "../utils/auth";

const readCachedUser = () => {
  try {
    const raw = localStorage.getItem("userData");
    return raw ? JSON.parse(raw) : null;
  } catch (_err) {
    return null;
  }
};

const Root = ({ component }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [animKey, setAnimKey] = useState(0);
  const [user, setUser] = useState(readCachedUser);

  useEffect(() => {
    setAnimKey((k) => k + 1);
  }, [pathname]);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    let cancelled = false;
    getCurrentUser().then((u) => {
      if (cancelled) return;
      if (!u) {
        navigate("/login", { replace: true });
        return;
      }
      setUser(u);
    });
    return () => { cancelled = true; };
  }, [navigate]);

  return (
    <div className="flex flex-col">
      <Header user={user} />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main
          key={animKey}
          className="flex-1 overflow-y-auto lg:ml-[339px] page-transition"
        >
          {component}
        </main>
      </div>
    </div>
  );
};

export default Root;
